module.exports = __webpack_public_path__ + "images/emoji/postal_horn.e6f6344e45e349201276.png";